export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/black-friday-badge-bg.0563de07.svg","height":20,"width":102};